var _circle, _circle2, _circle3, _circle4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 173,
    viewBox: "0 0 172 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86.1501,
    r: 86,
    fill: "#D71414",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 85.6501,
    r: 72.5,
    fill: "#D71414",
    fillOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86.1501,
    r: 59,
    fill: "#D71414",
    fillOpacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 87.1501,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.6842 42.4001C61.6217 42.4001 41.9342 62.0876 41.9342 86.1501C41.9342 110.213 61.6217 129.9 85.6842 129.9C109.747 129.9 129.434 110.213 129.434 86.1501C129.434 62.0876 109.747 42.4001 85.6842 42.4001ZM82.2467 61.1501H89.1217V95.5251H82.2467V61.1501ZM85.6842 114.275C83.1842 114.275 80.9967 112.088 80.9967 109.588C80.9967 107.088 83.1842 104.9 85.6842 104.9C88.1842 104.9 90.3717 107.088 90.3717 109.588C90.3717 112.088 88.1842 114.275 85.6842 114.275Z",
    fill: "#D71414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningWave);
export default __webpack_public_path__ + "static/media/WarningWave.576d36ea194daa9db49f45456ba0f4f6.svg";
export { ForwardRef as ReactComponent };